/**Development */
// export default {
//   imageBaseUrl: "https://devcdn.royalenfield.com",
//   serverUrl: "https://eu-we-api-dev2.royalenfield.com/v3",
// countryJsonUrl: "https://stagecdn.royalenfield.com/EU0001",
//   countryServlet: "https://stagecdn.royalenfield.com",
// };

/**UAT */
// export default {
//   imageBaseUrl: "https://stagecdn.royalenfield.com",
//   serverUrl: "https://eu-we-api-uat2.royalenfield.com/v3",
//   countryJsonUrl: "https://stagecdn.royalenfield.com/EU0001",
//   countryServlet: "https://stagecdn.royalenfield.com",
// };

/**Production */
export default {
  imageBaseUrl: "https://www.royalenfield.com",
  serverUrl: "https://eu-we-api.royalenfield.com/v3",
  countryJsonUrl: "https://euwereplatform.blob.core.windows.net/prod",
  countryServlet: "https://www.royalenfield.com",
};
